import MessageManager, { MessageStrategyTypes } from './MessageManager';
import { IMessageStrategy, PlainMessageStrategy, createPlainMessageStrategy } from './MessageManager/Strategy';
import { TMessageCode, TMessageName, IMessageData } from './interfaces';
import useMessageManager from './useMessageManager';

export type { IMessageStrategy, TMessageCode, TMessageName, IMessageData };
export {
  MessageManager,
  PlainMessageStrategy,
  createPlainMessageStrategy,
  MessageStrategyTypes,
  useMessageManager,
};
